/**
 * Format a date to a string in the format YYYY-MM-DDTHH:MM:SS, which corresponds to Rust's NaiveDateTime.
 */
export function formatNaiveDateTime(date: Date): string {
    const pad = (number: number) => (number < 10 ? '0' + number : number);

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // getMonth() returns 0-11
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}
